/** Academic Structure's user-visible vocabulary. */
export const structureCopy = {
    title: "Academic Structure",
    description: "Departments, programs, cohorts and terms keep their institutional records here.",
    failed: "These records could not be read.",
    stale: "The last values are kept. A later change may not be shown.",
    newer: "This record changed. Compare the latest values before saving again.",
    unknown: "No confirmation was received. Check this request before making another change.",
    check: "Check",
    checkNote: "Reads this request's receipt without sending the change again.",
    notRecorded: "The server has no committed change for this request. Review the kept draft before confirming again.",
    notChanged: "Not changed",
    keepMine: "Keep my values",
    loadNewer: "Load newer values",
    choose: "Choose a change",
    noPlacement: "No sections, enrollments or people are created or moved.",
    kinds: {
        department: {
            plural: "Departments", single: "department", create: "Create department", change: "Change department status", empty: "No departments are recorded."
        },
        program: {
            plural: "Programs", single: "program", create: "Create program", change: "Change program status", empty: "No programs are recorded."
        },
        cohort: {
            plural: "Cohorts", single: "cohort", create: "Create cohort", change: "Change cohort status", empty: "No cohorts are recorded."
        },
        semester: {
            plural: "Terms", single: "term", create: "Create term", change: "Change term status", empty: "No terms are recorded."
        },
    },
    fields: {
        name: "Name", description: "Description", lead_user_id: "Faculty lead", department_id: "Department", name_ar: "Arabic name", code: "Code", duration_label: "Duration", program_id: "Program", entry_year: "Entry year", label: "Cohort label", start_date: "Starts", end_date: "Ends", grades_due_date: "Grades due", status: "Status"
    },
    statuses: {
        active: "Active", inactive: "Retired", archived: "Archived", upcoming: "Upcoming", closed: "Closed", delete: "Delete empty department"
    },
    boundary: {
        department: "Retirement keeps programs, sections and enrollments. It does not block their work. Only an empty department can be deleted.",
        program: "Retirement removes this program from applicant choices. Existing sections and enrollments stay; their work is not blocked.",
        cohort: "Archiving removes this cohort from new placement choices. Existing learner records and enrollments stay.",
        semester: "Closing prevents new publication and enrollments. Existing published sections remain published; teaching and historical corrections stay available.",
    },
} as const;
